module.exports = __webpack_public_path__ + "img/gps_fixed-24px.1550246b.svg";